import type { AuthUser } from '@stayon/auth-core';
import { can, hasAnyRole, ROLE_GROUPS } from '@/shared/auth';
import { AVAILABILITY_DISTRIBUTION_SURFACE } from '@/shared/auth/privilegeSurfaces';

/**
 * Wer welche Seite des Kalender-Bereichs erreicht – dieselben Regeln, die der Router prüft.
 * Eigentümer behalten nur die Belegung (PO 2026-10-20): Verfügbarkeit & Vertrieb samt dem
 * Apartment-Reiter „Preise & Belegung“ hängen am Privileg, die Preisautomatik an der Rolle.
 */
export const CALENDAR_ROUTE_ROLES = ROLE_GROUPS.operationsOwner;
export const PRICING_ROUTE_ROLES = ROLE_GROUPS.staff;
export const AVAILABILITY_ROUTE_PRIVILEGE = AVAILABILITY_DISTRIBUTION_SURFACE.privilege;

export function calendarAreaAccess(user: AuthUser | null) {
  return {
    occupancy: hasAnyRole(user, ...CALENDAR_ROUTE_ROLES),
    availability: can(user, AVAILABILITY_ROUTE_PRIVILEGE),
    pricing: hasAnyRole(user, ...PRICING_ROUTE_ROLES),
  };
}
